export default "__VITE_ASSET__TLOOH_Vu__"